<template>
  <div>
    <v-card-title>
      <div class="body-2">Risk Text</div>
    </v-card-title>
    <v-tabs slider-color="teal">
      <v-tab ripple @click="changeRiskGrpUpperText">Risk Group Upper Text</v-tab>
      <v-tab ripple @click="changeLowerText">Lower Text</v-tab>
      <v-tab ripple @click="changeMemoText">Memo Text</v-tab>
    </v-tabs>
    <v-card>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <router-view ></router-view>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  methods: {
    changeRiskGrpUpperText() {
      this.$router.push({ name: 'riskGrpUpperText' })
    },
    changeLowerText() {
      this.$router.push({ name: 'lowerText' })
    },
    changeMemoText() {
      this.$router.push({ name: 'memoText' })
    }
  }
}
</script>
